import { render, staticRenderFns } from "./PosterTextSettings.vue?vue&type=template&id=0e3baf23&scoped=true&"
import script from "./PosterTextSettings.vue?vue&type=script&lang=js&"
export * from "./PosterTextSettings.vue?vue&type=script&lang=js&"
import style0 from "./PosterTextSettings.vue?vue&type=style&index=0&id=0e3baf23&lang=scss&scoped=true&"
import style1 from "./PosterTextSettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3baf23",
  null
  
)

export default component.exports